import { createSlice } from '@reduxjs/toolkit'

export const selectedLocationSlice = createSlice({
    name: 'selectedLocation',
    initialState: {
        value: undefined
    },
    reducers: {
        set: (state, action) => {
            state.value = action.payload;
        },
        unSet: state => {
            state.value = undefined;
        }
    }
})

// Action creators are generated for each case reducer function
export const { set, unSet } = selectedLocationSlice.actions

export default selectedLocationSlice.reducer